/* istanbul ignore file */
import React from 'react';
import { useExpenseUrl } from 'domain/shared/expense';
import { LinkButton } from 'framework/ui/ui-builder';

const ViewExpenseButton = (props: any) => {
  const { getSingleEntityUrl } = useExpenseUrl();

  return (
    <LinkButton url={getSingleEntityUrl} key="view-expense" outline {...props}>
      View
    </LinkButton>
  );
};

export default ViewExpenseButton;
